export const formatPhoneNumber = (phoneNumber) => {
  const lastThreeDigits = phoneNumber?.slice(-3);
  const formattedPhoneNumber = `+44 (0) XXX XXX X${lastThreeDigits}`;
  return formattedPhoneNumber;
};
